import React from "react";
import { MimaText, Modal } from "../../../components";
import { amountFormatter } from "../../../utils/utils";
import OrderTracker from "../MoneyExP2P/OrderTracker";

const ViewMoreInstantOrderInfo = ({ singleItem, closeModal }) => {
  return (
    <Modal closeModal={closeModal}>
      <div style={{ width: "38rem" }}>
        <OrderTracker item={singleItem} isExpress />

        <MimaText variant="subtitleBold" align="center" mb={2}>
          {` Buyer Info `}
        </MimaText>
        <div className="modal__beside__grid">
          <MimaText labelTitle="Full Name">
            {singleItem?.buyer?.firstname} {singleItem?.buyer?.lastname}
          </MimaText>
          <MimaText labelTitle="Username">
            {singleItem?.buyer?.username}
          </MimaText>

          <MimaText labelTitle="Buyer Pays">
            {amountFormatter(singleItem.buyerDebitValue.currencyCode).format(
              singleItem?.buyerDebitValue.amount
            )}
          </MimaText>
          <MimaText labelTitle="Buyer Receives">
            {amountFormatter(singleItem.buyerCreditValue.currencyCode).format(
              singleItem?.buyerCreditValue.amount
            )}
          </MimaText>
          <MimaText labelTitle="Reference Code">
            {singleItem?.referenceCode}
          </MimaText>
        </div>

        <MimaText variant="subtitleBold" align="center" mb={2} mt={4}>
          Buyer Account Details
        </MimaText>

        {singleItem.buyerBankInfo.foreign?.data?.length > 0 ? (
          <>
            {singleItem.buyerBankInfo.foreign?.data?.map((x, i) => (
              <MimaText mb={2} labelTitle={x.label} key={i}>
                {x.value}
              </MimaText>
            ))}
          </>
        ) : (
          <>
            <MimaText mb={2} labelTitle="Account Name">
              {singleItem.buyerBankInfo.accountName}
            </MimaText>

            <MimaText mb={2} labelTitle="Account Number">
              {singleItem.buyerBankInfo.accountNumber}
            </MimaText>
            <MimaText mb={2} labelTitle="Bank">
              {singleItem.buyerBankInfo.bank}
            </MimaText>
          </>
        )}

        {singleItem.buyerPaymentProofUrls.length > 0 && (
          <div>
            <MimaText variant="subtitleBold" mb={2} mt={4}>
              Buyer Payment Proof to Admin
            </MimaText>
            {singleItem.buyerPaymentProofUrls.map((x, i) => (
              <div
                key={i}
                style={{
                  width: "100%",
                  paddingInline: "3rem",
                }}
              >
                <img src={x} alt="Payment Proof" width="100%" />
                <div>
                  <a href={x} download="file.jpg">
                    Download file
                  </a>
                </div>
              </div>
            ))}
          </div>
        )}

        {singleItem.adminBuyerPaymentProofUrls.length > 0 && (
          <div>
            <MimaText variant="subtitleBold" mb={2} mt={4}>
              Admin Payment Proof to Buyer
            </MimaText>
            {singleItem.adminBuyerPaymentProofUrls.map((x, i) => (
              <div
                key={i}
                style={{
                  width: "100%",
                  paddingInline: "3rem",
                }}
              >
                <img src={x} alt="Payment Proof" width="100%" />
                <div>
                  <a href={x} download="file.jpg">
                    Download file
                  </a>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </Modal>
  );
};
export default ViewMoreInstantOrderInfo;
